import { takeLatest, put } from 'redux-saga/effects';

import * as myProviders from '../requests/my-providers-req';
import * as inspectReq from '../requests/inspection-req';
import { appointmentProgressActions } from '../progress-types';

function* handleInitRepeatableFlow({ payload }) {
  const { service, userId, visitType } = payload;
  yield put(appointmentProgressActions.setRescheduleData(payload));
  yield put(appointmentProgressActions.setVisitType(visitType));
  yield put(appointmentProgressActions.setService(service));
  yield put(
    inspectReq.actions.send({
      userId,
      inspectionFor: ['profile_form', 'documents_form'],
    }),
  );
}

export default function* repeatableScheduleFlow() {
  yield takeLatest(
    [myProviders.consts.SELECT_MY_PROVIDER],
    handleInitRepeatableFlow,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/repeatable-schedule-flow-saga.js